import type { Action } from "../../types/actions";
import type { DateType } from "../../types/states";

export const createEndDateAction = (newDate: DateType) => {
  const action: Action = { newDate, type: "endDate" };
  return action;
};

export const createStartDateAction = (newDate: DateType) => {
  const action: Action = { newDate, type: "startDate" };
  return action;
};

export const createGenreAction = (checkboxId: string) => {
  const action: Action = { checkboxId, type: "genre/checkbox" };
  return action;
};

export const createEventTypeAction = (checkboxId: string) => {
  const action: Action = { checkboxId, type: "eventType/checkbox" };
  return action;
};

export const createAvailabilityStatusAction = (checkboxId: string) => {
  const action: Action = { checkboxId, type: "availabilityStatus/checkbox" };
  return action;
};

export const createCollapseAction = (code: string) => {
  const action: Action = { code, type: "prefectures/collapse" };
  return action;
};

export const createAreaCheckboxAction = (code: string) => {
  const action: Action = { code, layer: "area", type: "prefectures/checkbox" };
  return action;
};

export const createPrefecturesAction = (code: string) => {
  const action: Action = {
    code,
    layer: "prefecture",
    type: "prefectures/checkbox",
  };
  return action;
};
